var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.58484581,10.66 C5.47947137,10.66 5.38726872,10.6209524 5.30823789,10.5428571 L0,5.31047619 L5.26872247,0.117142857 C5.42678414,-0.039047619 5.67704846,-0.039047619 5.82193833,0.117142857 C5.98,0.273333333 5.98,0.520634921 5.82193833,0.663809524 L1.11960352,5.31047619 L5.86145374,9.99619048 C6.01951542,10.152381 6.01951542,10.3996825 5.86145374,10.5428571 C5.78242291,10.6209524 5.69022026,10.66 5.58484581,10.66 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-291.000000, -320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Show-me-More",
    transform: "translate(252.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/right-arrow-Copy",
    transform: "translate(44.055176, 10.454590) rotate(-270.000000) translate(-44.055176, -10.454590) translate(40.555176, 4.454590)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(3.620000, 5.800000) scale(-1, 1) translate(-3.620000, -5.800000) translate(0.620000, 0.300000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowDown"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#010101",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    mask: "url(#mask-2)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.847619, -1.152432)",
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14.2380952,
    height: 14.4054054
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.60d601d8d8d54973b010b740984badca.svg";
export { ForwardRef as ReactComponent };